import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'campaign/list',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./CampaignList').default
      callback(null, component)
    }, 'CampaignList')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/CampaignList/index.js